import React, { useState } from 'react';

function SurveyStepSixteen({ formData, onNext }) {
    const [workloadRating, setWorkloadRating] = useState(formData.workloadRating || '');
    const [workloadComments, setWorkloadComments] = useState(formData.workloadComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!workloadRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ workloadRating, workloadComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 4: Workplace & Culture</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How manageable and fairly distributed do you find the workload? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`workload-rating-${option}`}
                            name="workloadRating"
                            value={option}
                            checked={workloadRating === option}
                            onChange={() => setWorkloadRating(option)}
                        />
                        <label htmlFor={`workload-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={workloadComments}
                    onChange={(e) => setWorkloadComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!workloadRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepSixteen;
